export default {
	name: 'BeatLeader',
	domain: 'https://beatleader.com',

	leftSaberColor: 'rgba(168,32,32,1)',
	rightSaberColor: 'rgba(32,100,168,1)',
};
